<template>
    <div class="ma-2">
        <!-- filter -->
        <v-row class="my-2">
            <v-col cols="12" lg="auto" md="6" sm="12" xs="12">
			    <slot name="breadcrumbs" :item="true"></slot>
		    </v-col>
            <v-col cols="auto">
                <v-autocomplete 
                    v-model="type"
                    :items="invoicesTypes"
                    item-text="name"
                    item-value="id"
                    dense
                    outlined
                    hide-details
                    :label="$t('inputs.type')"
                    @change="getInvoices()"
                />
            </v-col>
        </v-row>

        <bee-handy-table
            ref="table"
            :headers="headers"
            :items="invoices"
            :loading="loading"
            dense
            zebra
            :items-per-page="-1"
            hide-default-footer
        >
            <template v-slot:item.is_posted="{ item }">
                <v-chip :color="item.is_posted ? 'success  white--text'  : 'unpostedColor white--text'">
                    {{ item.is_posted ? $t('posted') : $t('unposted') }}
                </v-chip>
            </template>

            <template v-slot:item.actions="{ item }">
                <div class="d-flex justify-end">
                    <v-btn 
                        icon 
                        color="success" 
                        @click="itemId = item.id"
                        :to="{
                            name: type === 1 ? 'invoices-buy' : type === 2 ? 'invoices-sale' :  type === 3 ? 'buy-invoice-refund' : 'sale-invoice-refund',
                            params: {
                                id: item.id
                            }
                        }"
                    >
                        <v-icon>
                            mdi-eye
                        </v-icon>
                    </v-btn>
                </div>
            </template>
    </bee-handy-table>
    </div>
</template>
<script>
import { invoicesTypes } from '@/helpers/enums'
export default {
    data() {
        return {
            type: null,
            items: [],
            loading: false,
            invoices: [],
            invoicesTypes,
            itemId: null
        }
    },

    watch: {
        '$route.query.type'(val) {
            console.log(val)
            if(val) {
                this.type = val
            }
        }
    },

    computed: {
        headers() {
            return [
                {
                    text: this.$t('invoices.invoice-no'),
                    name: 'invoiceNo',
                    value: 'no'
                },
                {
                    text: this.$t('headers.type'),
                    name: 'type',
                    value: 'type',
                    setValueExpr: val => this.invoicesTypes.find(c => c.id === val)?.name,
                },
                {
                    text: this.$t('headers.state'),
                    name: 'is_posted',
                    value: 'is_posted'
                },
                {
                    text: this.$t('headers.date'),
                    name: 'date',
                    value: 'date'
                },
                {
                    text: '',
                    name: 'actions',
                    value: 'actions'
                },
                
            ]
        }
    },

    methods: {
        getInvoices() {
            this.loading = true
            this.$store.dispatch('invoices/fetchInvoicesNoPosted', { invoiceType: this.type }).then((data) => {
                this.$refs.table.resetShownRows()
                this.invoices = data
            }).finally(() => {
                this.loading = false
            })
        }
    },

    created() {
        if(this.$route.query.type) {
            this.type = this.$route.query.type
            this.getInvoices()
        }
    }
}
</script>
<!-- fetchInvoicesNoPosted -->